export const TERMS_AND_CONDITIONS = {
  LAST_UPDATED: 'Last Updated',
};
